import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Tag,
  Pagination,
  Menu,
  Dropdown,
  Modal,
} from "antd";
import Highlighter from "react-highlight-words";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import {
  ConsoleSqlOutlined,
  SearchOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { ImageView } from "../image/imageView";
import { LanguageContext } from "../../context/LanguageContext";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import { connect } from "react-redux";
import FindAccusedBaseSearchTable from "./FindAccusedBaseSearchTable";

const FindGhatakSearchTable = (props) => {
  console.log("props", props);
  const [criminalData, setCriminalData] = useState([]);
  const [criminalHeaders, setCriminalHeaders] = useState([]);
  const [searchText, setsearchText] = useState("");
  const [searchedColumn, setsearchedColumn] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [page, setPage] = useState(10);
  const [total, setTotal] = useState();
  const [key, setKey] = useState("");
  const [filter, setFilter] = useState(false);
  const [guna, setGuna] = useState(false);
  const [orderBy, setOrderBy] = useState();
  const [orderDirection, setOrderDirection] = useState();
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [name, setName] = useState();
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const { t } = useContext(LanguageContext);

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
     showGunaViewModel();
    if (data) {
     
      setGunaLoading(true);
      props.dispatch({ type: 'GET_CRIMINALS_BY_ID_SUCCESS', criminalViewList: {} });
      props.dispatch(professionalAction.getCriminalsViewsById(data));

    }
  };
  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (gunaLoading && props.professionals?.criminalViewList && Object.keys(props.professionals.criminalViewList).length > 0) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);
  const openImageModal = (img, name) => {
    setImageOpen(true);
    setSelectedImage(img);
    setName(name);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
    setName(null);
  };

  const filterkey = (e) => {
    console.log("e", e.key);
    setKey(e.key);
  };
  const requiredKeys = [
    "sr.no",
    "name",
    "age",
    "mobile_number",
    "districtName",
    // "gunhaCount",
  ];
  const requiredKeysTitle = [
    t("sr.no"),
    t("name"),
    t("age"),
    t("mobile_number"),
    t("accused_police_station"),
    // t("total_crimes"),
  ];

  const [search, setSearch] = useState(false);
  console.log("this.props.currentPage", props.current);
  const searchdata = () => {
    setCriminalData([]);
    if (searchText) {
      setSearch(true);
      professionalAction
        .getCriminalsAppInfoByCitySerach(
          props.selectedCity,
          searchText,
          currentPage,
          page
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              setTotal(criminal.totalItems);
              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                    // key: index + 1,
                  };
                });

              // columns1 && columns1.length && columns1.reverse();

              // let tempObj = columns1.map((res, index) => {
              //   return {
              //     ...res,
              //     photo:
              //       res.photo && res.photo[0] && res.photo[0].length
              //         ? res.photo[0]
              //         : null,
              //     // "Sr.No": props.getSerialNumber(
              //     //   index,
              //     //   props.current,
              //     //   props.pageSize
              //     // ),
              //   };
              // });
              setCriminalData(columns1);
              // console.log("setCriminalData", tempObj);
            });
        });
    }
  };
  const getFilterByGunaCriminalsTableInfoByCityId = (
    orderBy,
    orderDirection,
    currentPage,
    page
  ) => {
    setGuna(true);
    setOrderDirection(orderDirection);
    setOrderBy(orderBy);
    professionalAction
      .getFilterByGunaCriminalsTableInfoByCityId(
        props.selectedCity,
        currentPage,
        page,
        orderBy,
        orderDirection
      )
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            console.log("list", list);
            setTotal(criminal.totalCount);
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                  // key: index + 1,
                };
              });

            // columns1 && columns1.length && columns1.reverse();

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
                photo:
                  res.photo && res.photo[0] && res.photo[0].length
                    ? res.photo[0]
                    : null,
              };
            });
            setCriminalData(tempObj);
            console.log("setCriminalData", tempObj);
          });
      });
  };
  const handlePageChange = (pages) => {
    console.log("Page changed:", pages);
    setCurrentPage(pages - 1);
    if (guna) {
      getFilterByGunaCriminalsTableInfoByCityId(
        orderBy,
        orderDirection,
        currentPage,
        page
      );
    }
    if (filter) {
      searchfilter(orderBy, orderDirection, currentPage, page);
    }
  };

  const handlePageSizeChange = (current, size) => {
    console.log("Page size changed:", current);
    setPage(size);
    setCurrentPage(current);
    searchdata(searchText, current, size);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setsearchText("");
  };
  const clearFilters = () => {
    setsearchText("");
    setFilter(false);
    setSearch(false);
    const updatedData = props.criminalRecords.map((item, index) => ({
      ...item,
      "Sr.No": props.getSerialNumber(index, props.current, props.pageSize),
    }));
    setCriminalData(updatedData);
  };
  useEffect(() => {
    if (searchText && search) {
      searchdata(searchText, currentPage, page);
    }
  }, [searchText]);
  console.log("setCriminalData", criminalData);
  console.log("criminalHeaders", criminalHeaders);
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          //   ref={(node) => {
          //     setsearchInput(node);
          //   }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              console.log("e,target", e.target.value);
              handleSearch(selectedKeys, confirm, dataIndex);
              // setCurrentPage(0);
              searchdata(selectedKeys[0], currentPage, page);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            {t("search")}
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = async (selectedKeys, confirm, dataIndex) => {
    confirm();
    console.log("selected keys", selectedKeys, dataIndex);
    setsearchText(selectedKeys[0]);
    setsearchedColumn(dataIndex);
  };
  useMemo(() => {
    if (props.criminalRecords && props.criminalRecords) {
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
          };
        });

      // columns1 && columns1.length && columns1.reverse();
      console.log("props.cuurentpage", props.current);
      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
          photo:
            res.photo && res.photo[0] && res.photo[0].length
              ? res.photo[0]
              : null,
          index: props.getSerialNumber(index, props.current, props.pageSize),
        };
      });
      setCriminalData(tempObj);

      let tablelabes = columns1 && columns1.length && Object.keys(columns1[0]);
      tablelabes && tablelabes.unshift("Sr.No");

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          if (
            _.filter(requiredKeys, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });

      let columnList = tableColumns.map((item, index) => {
        return {
          title: requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });
      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);
  console.log("crimheader", criminalHeaders);
  console.log("userdata", props.usersData);
  const users = props.usersData;
  let columns = criminalHeaders.map((res) => {
    return {
      ...res,
    };
  });
  console.log("crime data", criminalData);

  columns = [
    {
      title: t("sr.no"),
      key: "index",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.index}
        </Space>
      ),
    },
    {
      title: t("name"),
      key: "name",
      render: (text, record) => (
        <Space size="middle" title={record.id} style={{ maxWidth: 300 }}>
          {record.name}
        </Space>
      ),
    },
    {
      title: t("age"),
      key: "age",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.age}
        </Space>
      ),
    },
    {
      title: t("phone_no"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.mobileNumber}
        </Space>
      ),
    },
    {
      title: t("accused_police_station"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.districtName}
        </Space>
      ),
    },
    {
      title: t("total_crimes"),
      key: "gunhaCount",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              onGunaForm(record.id);
            }}
          >
            {record.gunhaCount}
          </Button>
        </div>
      ),
    },
    {
      title: t("photo"),
      key: "photo",
      // filters: [
      //   {
      //     text: "फोटो",
      //     value: 1,
      //   },
      //   {
      //     text: "नाही",
      //     value: null,
      //   },
      // ],
      onFilter: (value, record) => {
        if (value) {
          return record.photo ? record.photo.split().length === value : null;
        } else {
          return record.photo === value;
        }
      },
      render: (text, record) => (
        <Space size="middle">
          {record.photo ? (
            <img
              style={{ width: 50, height: 50 }}
              src={
                "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                record.photo
              }
              onClick={() => openImageModal(record.photo, record.name)}
            ></img>
          ) : (
            "नाही"
          )}
        </Space>
      ),
    },
    {
      title: t("action"),
      key: "action",
      render: (text, record) => (
        console.log("record", record),
        (
          <Space size="middle">
            <a
              onClick={() => {
                handleEditForm(record);
              }}
            >
              Update
            </a>
            <a
              onClick={() => {
                handleViewForm(record.id);
              }}
            >
              View
            </a>
            <a
              onClick={() => {
                handlePreventiveViewForm(record.id);
              }}
            >
              Preventive
            </a>
            {props?.usersData?.cityId === record.city ? (
              <a
                onClick={() => {
                  handleActiveCriminal(record);
                }}
              >
                {record.activeUser && record.activeUser === 1 ? (
                  <Tag color="green">Active </Tag>
                ) : (
                  <Tag color="red">In Active</Tag>
                )}
              </a>
            ) : (
              ""
            )}
          </Space>
        )
      ),
    },
  ];
  // columns.push({
  //   ...{
  //     title: "Action",
  //     key: "action",
  //     render: (text, record) => (
  //       console.log("record", record),
  //       (
  //         <Space size="middle">
  //           <a
  //             onClick={() => {
  //               handleEditForm(record);
  //             }}
  //           >
  //             Update
  //           </a>
  //           <a
  //             onClick={() => {
  //               handleViewForm(record.id);
  //             }}
  //           >
  //             View
  //           </a>
  //           <a
  //             onClick={() => {
  //               handlePreventiveViewForm(record.id);
  //             }}
  //           >
  //             Preventive
  //           </a>
  //           {props?.usersData?.cityId === record.city ? (
  //             <a
  //               onClick={() => {
  //                 handleActiveCriminal(record);
  //               }}
  //             >
  //               {record.activeUser && record.activeUser === 1 ? (
  //                 <Tag color="green">Active </Tag>
  //               ) : (
  //                 <Tag color="red">In Active</Tag>
  //               )}
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </Space>
  //       )
  //     ),
  //   },
  // });
  const handleEditForm = (data) => {
    if (props.isAccusedFormUpdate && props.isAccusedFormUpdate) {
      props.onEditAccusedForm(data);
    } else {
      props.onEdituser(data);
    }
  };

  const handlePreventiveViewForm = (data) => {
    if (props.isAccusedFormUpdate && props.isAccusedFormUpdate) {
      props.onPreventiveViewAccusedForm(data);
    } else {
      props.onEdituser(data);
    }
    //props.onPreventiveViewAccusedForm(data);
  };

  const handleViewForm = (data) => {
    props.onViewAccusedDetails(data);
  };

  const handleActiveCriminal = (data) => {
    props.onCriminalActiveStatus(data);
  };

  const clear = () => {
    setsearchText("");
  };

  console.log("props.criminalRecords", props.criminalRecords);
  console.log("called componet new");
  const menu = (
    <Menu onClick={filterkey}>
      <Menu.Item key="name">
        {t("sort_by_name")}
        <ArrowDownOutlined
          onClick={() => searchfilter("name", "ASC", currentPage, page)}
        ></ArrowDownOutlined>
        <ArrowUpOutlined
          onClick={() => searchfilter("name", "DESC", currentPage, page)}
        />
      </Menu.Item>
      <Menu.Item key="age">
        {t("sort_by_age")}
        <ArrowDownOutlined
          onClick={() => searchfilter("age", "ASC")}
        ></ArrowDownOutlined>
        <ArrowUpOutlined onClick={() => searchfilter("age", "DESC")} />
      </Menu.Item>
      <Menu.Item key="districtName">
        {t("sort_by_police_station")}
        <ArrowDownOutlined
          onClick={() => searchfilter("districtName", "ASC", currentPage, page)}
        ></ArrowDownOutlined>
        <ArrowUpOutlined
          onClick={() =>
            searchfilter("districtName", "DESC", currentPage, page)
          }
        />
      </Menu.Item>
      <Menu.Item key="districtName">
        {t("sort_by_total_crimes")}
        <ArrowDownOutlined
          onClick={() =>
            getFilterByGunaCriminalsTableInfoByCityId(
              "id",
              "ASC",
              currentPage,
              page
            )
          }
        ></ArrowDownOutlined>
        <ArrowUpOutlined
          onClick={() =>
            getFilterByGunaCriminalsTableInfoByCityId(
              "id",
              "DESC",
              currentPage,
              page
            )
          }
        />
      </Menu.Item>
    </Menu>
  );
  const searchfilter = (orderBy, orderDirection) => {
    setFilter(true);
    setOrderDirection(orderDirection);
    setOrderBy(orderBy);
    if (searchText) {
      professionalAction
        .getFilterSearchCriminalsTableInfoByCityId(
          props.selectedCity,
          searchText,
          currentPage,
          page,
          orderBy,
          orderDirection
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              console.log("list", list);
              setTotal(criminal.totalCount);
              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                    // key: index + 1,
                  };
                });

              // columns1 && columns1.length && columns1.reverse();

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                  photo:
                    res.photo && res.photo[0] && res.photo[0].length
                      ? res.photo[0]
                      : null,
                };
              });
              setCriminalData(tempObj);
              console.log("setCriminalData", tempObj);
            });
        });
    } else {
      professionalAction
        .getFilterCriminalsTableInfoByCityId(
          props.selectedCity,
          currentPage,
          page,
          orderBy,
          orderDirection
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              setTotal(criminal.totalItems);
              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                    // key: index + 1,
                  };
                });

              // columns1 && columns1.length && columns1.reverse();

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                  photo:
                    res.photo && res.photo[0] && res.photo[0].length
                      ? res.photo[0]
                      : null,
                };
              });
              setCriminalData(tempObj);
              console.log("setCriminalData", tempObj);
            });
        });
    }
  };
  console.log("props", props);
  console.log("filter...", filter);
  const handleInputChange = (e) => {
    setsearchText(e);
  };
  return (
    <>
      {/* Modern Filter Row */}
      <div
        className="filter-row"
        style={{
          padding: "16px 20px",
          background: "#fff",
          borderRadius: "8px",
          border: "1px solid #f0f0f0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            alignItems: "center",
          }}
          className="button-group-responsive"
        >
          {/* Search Input */}
          <div
            style={{
              flex: "1 1 300px",
              minWidth: "250px",
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={(e) => handleInputChange(e.target.value)}
              style={{ flex: "1", borderRadius: "6px" }}
              allowClear
            />
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Button
                type="primary"
                onClick={() => searchdata()}
                icon={<SearchOutlined />}
                className="modern-button modern-button-success"
                disabled={!searchText}
              >
                {t("search")}
              </Button>
              {search && (
                <Button
                  onClick={() => clearFilters()}
                  className="modern-button modern-button-danger"
                >
                  {t("clear")}
                </Button>
              )}
            </div>
          </div>

          {/* Sort and Clear Buttons */}
          {!search && (
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                flex: "0 0 auto",
              }}
            >
              <Dropdown
                overlay={menu}
                placement="bottomRight"
                arrow={{ pointAtCenter: true }}
              >
                <Button className="modern-button modern-button-success">
                  {t("sorter_by")}
                </Button>
              </Dropdown>
              {(filter || guna) && (
                <Button
                  className="modern-button modern-button-danger"
                  onClick={() => clearFilters()}
                >
                  {t("clear")}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Total Count Display */}
      <div
        style={{
          marginBottom: "16px",
          padding: "12px 16px",
          background: "#f8f9fa",
          borderRadius: "6px",
          border: "1px solid #e9ecef",
        }}
      >
        <span style={{ color: "#666", fontSize: "14px" }}>{t("total")}:</span>
        <span
          style={{
            fontWeight: "bold",
            marginLeft: "8px",
            fontSize: "16px",
            color: "#1890ff",
          }}
        >
          {search || filter || guna ? total : props.total}
        </span>
      </div>

      {/* Table Section */}
      {search || filter || guna ? (
        <FindAccusedBaseSearchTable
          search={searchText}
          clear={clear}
          isAccusedFormUpdate={true}
          onEditAccusedForm={handleEditForm}
          onPreventiveViewAccusedForm={handlePreventiveViewForm}
          onViewAccusedDetails={handleViewForm}
          onCriminalActiveStatus={handleActiveCriminal}
          criminalRecords={criminalData}
          columns={columns}
          usersData={props.usersData}
          current={currentPage}
          pageSize={page}
          total={total}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
          cityid={props.selectedCity}
          getSerialNumber={props.getSerialNumber}
          professionals={props.professionals}
          user={props?.user}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={criminalData}
          pagination={{
            current: props.currentPage,
            pageSize: props.pageSize,
            total: props.total,
            onChange: props.handlePageChange,
            has_previous: props.pageSize > 1,
            previous: props.pageSize - 1,
            has_next: props.pageSize < props.total,
            next: props.total + 1,
            last_page: Math.ceil(props.total / props.pageSize),
            onShowSizeChange: props.handlePageSizeChange,
          }}
        />
      )}
      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          name={name}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
        />
      )}

      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={props.professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(props?.professionals?.criminalViewList?.gunhaInfor) &&
            props?.professionals?.criminalViewList?.gunhaInfor.length > 0
              ? props?.professionals?.criminalViewList?.gunhaInfor
              : []
          }
          address={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          name={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={gunaLoading}
          user_details={props?.user}
          masterId={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props?.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
        ></ViewGunaDetails>
      </Modal>
    </>
  );
};
export default connect()(FindGhatakSearchTable);
